import React from "react";
import { MdOutlineDeleteForever } from "react-icons/md";
import Swal from "sweetalert2";
import { withNamespaces } from "react-i18next";

const DeleteButton = ({ onDelete, t }) => {
  const handleDelete = () => {
    Swal.fire({
      title: t("deleteConfirmation.title"),
      text: t("deleteConfirmation.text"),
      icon: t("deleteConfirmation.icon"),
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("deleteConfirmation.confirmButtonText"),
    }).then((result) => {
      if (result.isConfirmed) {
        // Call the onDelete function passed from the parent
        onDelete();
      }
    });
  };

  return (
    <>
      <button className="large-icon mr-1" onClick={handleDelete}>
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_3810_24486)">
            <path
              d="M3.66602 6.41699H18.3327"
              stroke="#780408"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4.58398 6.41699L5.50065 17.417C5.50065 17.9032 5.69381 18.3695 6.03762 18.7134C6.38144 19.0572 6.84775 19.2503 7.33398 19.2503H14.6673C15.1535 19.2503 15.6199 19.0572 15.9637 18.7134C16.3075 18.3695 16.5006 17.9032 16.5006 17.417L17.4173 6.41699"
              stroke="#780408"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.25 6.41667V3.66667C8.25 3.42355 8.34658 3.19039 8.51849 3.01849C8.69039 2.84658 8.92355 2.75 9.16667 2.75H12.8333C13.0764 2.75 13.3096 2.84658 13.4815 3.01849C13.6534 3.19039 13.75 3.42355 13.75 3.66667V6.41667"
              stroke="#780408"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.16602 11L12.8327 14.6667M12.8327 11L9.16602 14.6667"
              stroke="#780408"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_3810_24486">
              <rect width="22" height="22" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </button>
    </>
  );
};

export default withNamespaces()(DeleteButton);
